import { related, sourceIds } from './quests__power-lines.mdx';

export { sourceIds, related };
export const quickAnswer =
  'Power Lines 属于 Contain the Crisis：完成 Arish’s Briefing 后依次核对车站改道目标，再先完成 Calibrate Platform A、后完成 Calibrate Platform B，最后与 Dr. Florez 交谈。';

## Power Lines 前置条件

Power Lines 属于 Contain the Crisis 流程，接在 Arish’s Briefing 后。先核对日志是否已经进入对应目标。

## 主要任务目标

- Reroute Perimeter Station：核对 Perimeter 的改道目标。
- Reroute Factory Station：核对 Factory 的改道目标。
- Reroute East Park Station：核对 East Park 的改道目标。
- Reroute Vanished Station：核对 Vanished Station 的目标。
- Calibrate Platform A：先完成平台 A 校准。
- Calibrate Platform B：A 完成后再校准平台 B。

以上英文用于对应日志，中文说明不是官方 UI 译名。

## Perimeter Station 怎么完成？

车站改道需要放置校准单元，再操作调谐装置。先对照当前日志与场景标记，单元放下不等于已经激活。

## Factory Station 怎么完成？

Factory 的单元排列成直线。核对标记位置，放好后启动车站调谐装置。

## East Park Station 怎么完成？

先清除遮挡放置标记的霉菌，再放置校准单元并操作装置。

## Vanished Station

核对日志是否已进入这个目标，再推进至平台校准。下面分别列出 A 和 B 的操作，不能交换完成顺序。

## Platform A 和 Platform B 校准

把校准单元放到标记位置，启动车站调谐装置。Factory 的单元排列成直线；East Park 要先清除遮挡放置标记的霉菌。

## 平台 A 校准

先给平台 B 的两个盒子供电以到达 A。利用 A 的供电打开楼上门，取回单元。断电后清除重新生长的霉菌，放好两个单元，再启动 A。

## 平台 B 校准

通电让霉菌生长，再断电清除两侧放置区的霉菌。保留中间连接电线的导电霉菌，放好两个单元后启动 B。

## 常见卡点

必须先完成 A。如果中间导电霉菌被清掉，重新供电让它生长；放置区受阻时，在断电状态下清理。

## 后续流程

清除剩余敌人，再与 Dr. Florez 交谈。检查日志内其他目标，相关任务见 [Into the Sinkhole](/quests/into-the-sinkhole)。
